module.exports = __webpack_public_path__ + "static/013-6801ae2aafffdd21cb95acce86fd6bed.jpg";